import React from 'react'

const LaptopIcon = ({ className = '', color = '#1772F5' }) => {
  return (
    <svg
      width="26"
      height="20"
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.9375 1.875C22.153 1.875 22.3597 1.9606 22.512 2.11298C22.6644 2.26535 22.75 2.47201 22.75 2.6875V14.875H3.25V2.6875C3.25 2.47201 3.3356 2.26535 3.48798 2.11298C3.64035 1.9606 3.84701 1.875 4.0625 1.875H21.9375ZM4.0625 0.25C3.41603 0.25 2.79605 0.506807 2.33893 0.963927C1.88181 1.42105 1.625 2.04103 1.625 2.6875V16.5H24.375V2.6875C24.375 2.04103 24.1182 1.42105 23.6611 0.963927C23.204 0.506807 22.584 0.25 21.9375 0.25H4.0625ZM0 17.3125H26C26 17.959 25.7432 18.579 25.2861 19.0361C24.829 19.4932 24.209 19.75 23.5625 19.75H2.4375C1.79103 19.75 1.17105 19.4932 0.713927 19.0361C0.256807 18.579 0 17.959 0 17.3125H0Z"
        fill={color}
      />
    </svg>
  )
}

export default LaptopIcon
